import createReducer from '../createReducer'
import {
  GET_USER_GOALS_SUCCESS,
  LOAD_VIEW_GOALS_PAGE_SUCCESS,
  LOAD_VIEW_GOALS_PAGE_LOADING,
  STOP_GOAL_LOADING,
  STOP_GOAL_SUCCESS,
  CREATE_GOAL_LOADING,
  CREATE_GOAL_SUCCESS,
} from './constants'

export const initialState = {
  viewGoalsLoading: true,
  noGoalsFound: false,
  userGoals: [],
  createGoalLoading: false,
}

export default createReducer(initialState, {
  [GET_USER_GOALS_SUCCESS]: (state, action) => {
    const { data } = action.payload
    const goals = data._embedded.user_goals

    const goalsWithPerformace = goals.map((goal) => {
      goal.performance = {}
      return goal
    })

    return {
      ...state,
      userGoals: goalsWithPerformace,
    }
  },
  [LOAD_VIEW_GOALS_PAGE_LOADING]: (state) => {
    return { ...state, viewGoalsLoading: true, noGoalsFound: false }
  },
  [LOAD_VIEW_GOALS_PAGE_SUCCESS]: (state, action) => {
    // See corresponding unit tests for more thorough
    // explaination of what is happening here.
    const userGoals = state.userGoals.map((goal) => {
      const goalId = goal._links.self[0].id

      const goalProgress = action.payload.filter((progress) => {
        return goalId === progress.value.data._embedded.user_goal_progresses[0]._links.user_goal[0].id
      })[0].value.data._embedded.user_goal_progresses[0]

      const goalPerformance = goalProgress.performance[0].metrics.filter((perfMetric) => {
        return goal.criteria[0].threshold_metrics[0][0].data_type_field === perfMetric.data_type_field
      })[0]

      goal.progress = goalProgress
      goal.performance = goalPerformance

      return goal
    })

    const filteredUserGoals = userGoals.filter((goal) => {
      return goal.period === 'P1W'
    })

    return {
      ...state,
      userGoals: filteredUserGoals,
      viewGoalsLoading: false,
      noGoalsFound: (filteredUserGoals.length === 0),
    }
  },
  [STOP_GOAL_LOADING]: (state) => {
    return { ...state, viewGoalsLoading: true }
  },
  [STOP_GOAL_SUCCESS]: (state, action) => {
    const { deletedGoal } = action.meta

    const updatedUserGoals = state.userGoals.filter((goal) => {
      return deletedGoal !== goal._links.self[0].id
    })

    return {
      ...state,
      userGoals: updatedUserGoals,
      noGoalsFound: (updatedUserGoals.length === 0),
      viewGoalsLoading: false,
    }
  },
  [CREATE_GOAL_LOADING]: (state) => {
    return { ...state, createGoalLoading: true }
  },
  [CREATE_GOAL_SUCCESS]: (state) => {
    return { ...state, createGoalLoading: false }
  },
})
